import type { Iso8601, Uuid } from '@/shared/types/api/common';
import type { FulfillmentStatus } from '@/shared/types/api/parcels';

export const WEIGHT_UNIT_VALUES = ['kg', 'g'] as const;
export type WeightUnit = (typeof WEIGHT_UNIT_VALUES)[number];

/** Product summary embedded in a package's parcel rows / picker rows. */
export type ApiPackagesParcelProduct = {
  // Backend `DeclarationProductSerializer` emits `full_name` (was mis-typed as
  // `name`, which is never populated).
  full_name: string;
  quantity: number;
  price_per_item: number;
};

/** Parcel summary used by the picker endpoint (eligible candidates). */
export type ApiPackagesParcelPickerItem = {
  id: Uuid;
  trek_id: string;
  name: string;
  cargo_id_code: string | null;
  products: ApiPackagesParcelProduct[];
  passport_series: string;
  pinfl: string;
  fulfillment_status: FulfillmentStatus;
  created_at: Iso8601;
};

/** Embedded parcel inside a `package.parcels[]` row. */
export type ApiPackagesEmbeddedParcel = {
  id: Uuid;
  trek_id: string;
  name: string;
  cargo_id_code: string | null;
  passport_series: string;
  pinfl: string;
  products: ApiPackagesParcelProduct[];
  fulfillment_status: FulfillmentStatus;
  created_at: Iso8601;
};

export type ApiPackagesParcelLink = {
  order: number;
  parcel: ApiPackagesEmbeddedParcel;
};

export type ApiPackagesGetItem = {
  id: Uuid;
  name: string;
  price: number | string;
  weight: number | string | null;
  weight_unit: WeightUnit;
  party_id: Uuid | null;
  party: { id: Uuid; name: string } | null;
  created_by: Uuid | null;
  created_at: Iso8601;
  updated_at: Iso8601;
  parcels: ApiPackagesParcelLink[];
  parcels_count: number;
};

export type ApiPackagesListParams = {
  page?: number;
  page_size?: number;
  search?: string;
};

export type ApiPackagesListResponse = {
  results: ApiPackagesGetItem[];
  count: number;
  next: string | null;
  previous: string | null;
};

export type ApiPackagesPostBody = {
  name: string;
  weight?: number | string | null;
  weight_unit?: WeightUnit;
  parcel_ids: Uuid[];
};

export type ApiPackagesPatchBody = Partial<ApiPackagesPostBody>;

export type ApiPackagesParcelPickerParams = {
  q?: string;
};

export type ApiPackagesParcelPickerResponse = ApiPackagesParcelPickerItem[];
